import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class UnblockUserUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getUnblockUser(req);
    }
}
export default UnblockUserUseCase;
